import { render, staticRenderFns } from "./WxUserChart.vue?vue&type=template&id=7db5946c&scoped=true"
import script from "./WxUserChart.vue?vue&type=script&lang=js"
export * from "./WxUserChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5946c",
  null
  
)

export default component.exports